import { List, Datagrid, NumberField, EditButton, TextField } from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useRouteId } from "@/utils/route-utility";

export const ProjectInayatList = () => {
  const projectId = useRouteId();
  if (!projectId) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="text.secondary">
          Open a project from the Projects list to manage Inayat.
        </Typography>
      </Box>
    );
  }
  return (
    <List perPage={25} sort={{ field: "receivedDate", order: "DESC" }} filter={{ projectId }}>
      <Datagrid rowClick="edit">
        <NumberField source="amount" options={{ style: "currency", currency: "INR" }} />
        <DisplayDateField source="receivedDate" />
        <TextField source="reference" emptyText="—" />
        <EditButton />
      </Datagrid>
    </List>
  );
};
